<template>
    <div class="home" :style="{ minHeight: bodyHeight + 'px' }">
        <gHead2 />
        <div class="gContent" :style="{ minHeight: bodyHeight - 400 + 'px' }">
            <div class="login-box">
                <div class="login-content-box">
                    <div class="login-content-box-1">
                        <div class="login-content-box-1-top s-red-color">参展申请</div>
                        <div class="login-content-box-1-bottom">
                            <Form class="F" ref="formInline" :model="formInline" :rules="ruleInline"
                                @keyup.enter.native="handleSubmit('formInline')">
                                <FormItem class="F-1" prop="user">
                                    <Input class="I" type="text" v-model="formInline.user" placeholder="用户名" />
                                </FormItem>
                                <FormItem class="F-1" prop="password">
                                    <Input class="I" type="password" v-model="formInline.password" placeholder="密码" />
                                </FormItem>
                                <FormItem class="F-1" prop="captcha">
                                    <Input class="I" v-model="formInline.captcha" placeholder="验证码" />
                                    <img class="code" :src="code.image" alt="验证码" v-if="code && code.image"
                                        @click="getCode" />
                                </FormItem>
                                <div class="F-2">
                                    <!-- <p class="F-2-text">忘记密码 ？</p> -->
                                </div>
                                <Button type="primary" @click="handleSubmit('formInline')" size="large"
                                    :loading="loading" style="width: 75px; margin: 0 auto;"
                                    class="s-btn-red">登录</Button>
                                <Button type="primary" @click="$router.push('/join/basic')" size="large"
                                    style="width: 150px; margin: 20px auto 0; height: 40px"
                                    class="s-btn-red">新展商申请入口</Button>
                                <p class="login-re">
                                    <span @click="$router.push('/join-loginEn')">For the International Hall Booth
                                        Application</span>
                                </p>
                            </Form>
                        </div>
                    </div>
                </div>
                <iModal style="width: 600px;" v-model="model1" title="提示" class-name="vertical-center-modal"
                    :footer-hide="true">
                    <div style="margin-bottom:20px;text-align:center">
                        <p style="font-weight: bold;margin-bottom:15px">
                            您好，欢迎参加中国国际医疗器械博览会
                        </p>
                        申请展位您需要先准备好以下材料
                    </div>
                    <a href="javascript:;" style="margin: 40px 30px; " class="s-green-color" @click="getfile()">
                        •&nbsp;&nbsp;点击下载
                        展商申请意向表（需盖公司公章，展位申请时需上传）</a>
                    <!-- <a href="/static/87cmef上海展位报名表.doc" download="87cmef上海展位报名表.doc" style="margin: 40px 30px; " class="s-green-color" >
            •&nbsp;&nbsp;点击下载
            展商申请意向表（需盖公司公章，展位申请时需上传）</a> -->

                    <!-- <a href="/static/主场搭建车证申请批量导入模板.xlsx"
                     target="_blank"
                     download="车证申请批量导入模板.xlsx"
                     class="applyCss down_excel">点击下载</a> -->
                    <div style="margin:10px 30px">
                        •&nbsp;&nbsp;企业营业执照电子版/图片
                    </div>

                    <div
                        style="margin:20px 20px 0;padding:10px;background-color:#f7f7f7;line-height:1.5em;border-radius:5px;">
                        iCMEF是国药励展CMEF唯一官方出品“全球医疗健康产业线上空间”，主要提供CMEF展商及产品的搜索、供需发布及对接、商务洽谈、获取门票等在线服务。请认准iCMEF官方网站（i.cmef.com.cn）及小程序（“iCMEF”
                        ） ，谨防诈骗，避免不必要的损失。
                    </div>
                    <div class="button" @click="model1 = false">
                        确认
                    </div>
                </iModal>


                <iModal style="width: 600px;" v-model="model2" title="提示" class-name="vertical-center-modal"
                    :footer-hide="true">
                    <div style="margin-bottom:20px;    line-height: 25px;">
                        <p style="font-weight: bold;margin-bottom:15px;text-align: center;">
                            关于通过官方渠道参与会展的提示
                        </p>
                        近日，我公司发现行业内频有关于CMEF的不实招商信息传播。对此，我公司郑重提示如下：关于CMEF的参展报名途径，请务必跟CMEF组委会工作人员进行核实，谨慎识别招商主体的身份。
                        <p>我公司将尽最大努力维护展会秩序，积极维护参展商的相关权益。</p>
                        <p>特此提示。</p>

                        <div style='float: right;'>
                            <p>国药励展展览有限责任公司</p>
                            <p>2024年【11】月【23】日</p>
                        </div>
                    </div>


                    <!-- <div
                        style="margin:20px 20px 0;padding:10px;background-color:#f7f7f7;line-height:1.5em;border-radius:5px;">
                        iCMEF是国药励展CMEF唯一官方出品“全球医疗健康产业线上空间”，主要提供CMEF展商及产品的搜索、供需发布及对接、商务洽谈、获取门票等在线服务。请认准iCMEF官方网站（i.cmef.com.cn）及小程序（“iCMEF”
                        ） ，谨防诈骗，避免不必要的损失。
                    </div> -->
                    <div class="button" style='margin-top:60px' @click="model2 = false">
                        确认
                    </div>
                </iModal>
            </div>
        </div>
        <gBottom />
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import gHead2 from "@components/gHead2/gHead2.vue";
import gBottom from "@components/gBottom/gBottom.vue";
import config from "@assets/config.json";

export default {
    name: "audience-login",
    data() {
        return {
            model2: false,
            model1: false,
            bodyHeight: "800px",
            loading: false,
            formInline: {
                user: "",
                password: "",
                captcha: "",
            },
            ruleInline: {
                user: [{ required: true, message: "用户为必填选项", trigger: "blur" }],
                password: [
                    { required: true, message: "账号或密码错误", trigger: "blur" },
                    {
                        type: "string",
                        min: 4,
                        message: "密码不能小于4位",
                        trigger: "blur",
                    },
                    {
                        type: "string",
                        max: 50,
                        message: "密码不能大于50位",
                        trigger: "blur",
                    },
                ],
                captcha: [{ required: true, message: "验证码必填", trigger: "blur" }],
            },
            code: null, // 二维码信息
        };
    },
    components: {
        gHead2,
        gBottom,
    },
    computed: {
        ...mapGetters({
            company: "loginModule/getCompany",
            ExhibitionIdArr: 'getExhibitionIdArr',
        }),
    },
    async created() {
        await this.getAllConfiSettle('centre');
        this.bodyHeight = window.innerHeight ? window.innerHeight : "800";
        this.getCode();
        console.log('ExhibitionIdArr', this.ExhibitionIdArr);
    },
    methods: {
        ...mapMutations({
            setJoinToken: "setJoinToken",
            setTokenTime: "setTokenTime",
        }),
        ...mapActions({
            getAllConfiSettle: "getAllConfiSettle",
            getImgCode: "loginModule/getImgCode",
            validateImgCode: "loginModule/validateImgCode",
            getJoinToken: "getJoinToken",
            getJoinUser: "getJoinUser",
            getJoinCompany: "getJoinCompany",
            getExIdByUserId: "getExIdByUserId",
            getExhibitionById: "getExhibitionById",
            getJoinInfo: "getJoinInfo",
            getwordfile: "getwordfile",
            getApplyConfig: "getApplyConfig",
        }),
        async getCode() {
            // 获取code
            this.code = await this.getImgCode();
        },
        validForm(name) {
            // 验证表单
            return new Promise((resolve, reject) => {
                this.$refs[name].validate((valid) => {
                    resolve(valid);
                });
            });
        },
        async validCode() {
            // 验证code
            if (!this.code || !this.formInline.captcha) return false;
            let valid = await this.validateImgCode({
                Key: this.code.key,
                Code: this.formInline.captcha,
            });
            if (!valid) {
                this.$Message.error("验证未通过!");
                return false;
            }
            if (valid.errors && valid.errors[0]) {
                this.$Message.error(valid.errors[0].description);
                this.getCode();
                return false;
            }
            return true;
        },
        async handleSubmit(name) {
            let form = this.formInline;
            let valid = await this.validForm(name);
            if (!valid) return;
            let codeValid = await this.validCode();
            if (!codeValid) return;
            let formData = {
                grant_type: "password",
                client_id: "cloud.exhibition",
                client_secret: "secret",
                username: form.user,
                password: form.password,
                scope: "synair offline_access",
            };
            this.loading = true;
            setTimeout((c) => {
                this.loading = false;
            }, 5000);
            let tokenData = await this.getJoinToken(formData);
            if (tokenData && tokenData.data.access_token) {
                this.setJoinToken(tokenData.data.access_token);
                this.setTokenTime(
                    tokenData.data.expires_in * 1000 + new Date().getTime()
                );
                let user = await this.getJoinUser();
                let company = await this.getJoinCompany(user.id);
                if (!company) {
                    this.$Message.warning("未绑定公司信息！");
                    return;
                } else {
                    // console.log("公司信息：", company);
                    let idInfo = await this.getExIdByUserId(user.id);
                    if (idInfo && idInfo.ExhibitionId) {
                        if (this.ExhibitionIdArr.indexOf(idInfo.ExhibitionId) !== -1) {
                            let exhibitionId = idInfo.ExhibitionId;
                            let exData = await this.getExhibitionById(exhibitionId);
                            // console.log("展会信息：", exData);
                            let joinInfo = await this.getJoinInfo({
                                ExhibitionId: exhibitionId,
                            });
                            if (joinInfo) {
                                this.$Message.success("登录成功");
                                this.$router.push("/join/basic?userId=" + user.id);
                            } else {
                                this.$Message.warning("未绑定展会信息！");
                            }
                        } else {
                            this.$Message.warning("未绑定展会信息！");
                        }
                    } else {
                        this.$Message.warning("未绑定展会信息！");
                    }
                }
            }
            this.loading = false;
        },
        goEnLink() {
            this.$router.push("/join-loginEn");
        },
        async getfile() {
            let data1 = await this.getApplyConfig();
            //   let key1 = data1.fileApplyTable.split("key=")[1];
            let key1 = data1.fileApplyTable
            let opt = {
                key: key1,
                name: data1.fileApplyTableName
            }
            //   let data = await this.getwordfile(opt);
            // this.downloadUrl(key1)
            this.getBlob(key1).then(blob => {
                this.DownloadItem(blob, '第88届CMEF展位申请表');
            });
        },
        downloadUrl(url) {
            // console.log(url);
            let link = document.createElement('a')
            //创建一个a标签
            link.style.display = 'none'
            //将a标签隐藏
            link.href = url
            //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
            link.setAttribute('download', '第88届CMEF展位申请表')
            // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
            document.body.appendChild(link)
            //将上面创建的a标签加入到body的尾部
            link.click()
            //执行a标签
        },


        getBlob(url) {
            return new Promise(resolve => {
                const xhr = new XMLHttpRequest();
                xhr.open('GET', url, true);
                xhr.responseType = 'blob';
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        resolve(xhr.response);
                    }
                };
                xhr.send();
            });
        },

        DownloadItem(blob, fileName) {
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
        },



    },
};
</script>

<style scoped lang="scss">
@import "@assets/scss/utils.scss";

.home {
    background: #fff;
}

.gContent {
    .login-box {
        width: 1200px;
        margin: 0 auto;
        display: flex;

        &-entrance {
            width: 420px;
            padding: 0 44px;
            margin: 70px auto 0;
            display: flex;
            justify-content: space-between;

            p {
                height: 40px;
                font-size: 18px;
                cursor: pointer;
            }
        }
    }
}

.top-title {
    height: 50px;
    font-size: 14px;
    line-height: 35px;

    &-link {
        color: #999;
    }
}

.main {
    width: 1200px;
    margin-top: 20px;
    margin-bottom: 80px;
    @include clearfix;

    .section {
        width: 878px;
        border-radius: 2px;
        background-color: #fff;
        float: left;

        .section-top {
            // padding: 50px 65px;
            box-shadow: 0px 1px 3px 0px rgba(95, 99, 104, 0.1);
            border-bottom: 20px solid #f5f5f5;

            .m-content {
                padding: 23px 60px 50px;
            }
        }

        .title {
            position: relative;
            padding-left: 20px;
            display: flex;
            align-items: center;
            height: 60px;
            border-bottom: 1px solid #f5f5f5;

            span {
                display: inline-block;
                width: 4px;
                height: 16px;
                background-color: #d13119;
            }

            h3 {
                display: inline-block;
                font-size: 16px;
                line-height: 18px;
                color: #333;
                margin-left: 15px;
            }
        }
    }

    .sidebar {
        width: 300px;
        float: right;
        @include empty-txt(200px, "加载中...");
    }
}

.m-info {
    height: 160px;
    background-color: #fff;
    padding: 20px;
    margin-top: 28px;

    &-title {
        font-size: 24px;
        font-weight: bold;
        color: #333;
        // margin-bottom: 10px;
    }

    &-brand {
        display: flex;
        align-items: center;

        // margin-bottom: 6px;
        .brand {
            align-items: center;
            display: flex;
            margin-right: 15px;
            color: #999;

            span {
                font-size: 16px;
            }

            i {
                font-size: 22px;
            }

            .icon-chakan {
                font-size: 24px;
            }
        }
    }

    &-line {
        margin-right: 10px;
        // margin-bottom: 4px;
        display: flex;
        align-items: center;

        i {
            font-size: 20px;
        }
    }
}

.m-content {
    p {
        padding: 43px 0;
    }

    img {
        width: 100%;
    }
}

.section-bot {
    border-bottom: 20px solid #f5f5f5;
    width: 100%;
    background-color: #fff;
}

.company_info {
    height: 200px;
    padding: 20px 18px;
    box-shadow: 0px 1px 3px 0px rgba(95, 99, 104, 0.1);
    border-radius: 2px;
    border-bottom: 1px solid #ebebec;
    margin-bottom: 20px;
    position: relative;
    background-color: #fff;
    display: flex;
    align-items: center;

    .img {
        border: 1px solid rgba(204, 204, 204, 0.4);
        width: 158px;
        height: 158px;
        float: left;
        @include clearfix;

        img {
            width: 100%;
            height: 100%;
        }
    }
}

.company_info .info {
    float: left;

    @include clearfix;

    margin-left: 20px;

    h3 {
        font-size: 24px;
        line-height: 24px;
        font-weight: bold;
        color: #333;
        padding-bottom: 10px;
        width: 25em;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

.company_info .btn {
    height: 100%;
    position: absolute;
    top: 20px;
    right: 20px;
}

.int-video {
    width: 750px;
    height: 500px;
    margin: 10px 0;
}

.sidebar-info {
    width: 300px;
    padding: 30px;
    border-radius: 3px;
    box-shadow: 0px 1px 3px 0px rgba(95, 99, 104, 0.1);
    border-radius: 2px;
    background-color: #fff;
    margin-bottom: 20px;
    text-align: center;
    position: relative;

    p {
        font-size: 16px;
        color: rgb(0, 0, 0);
        margin-bottom: 20px;
        text-align: left;

        &:first-child,
        &:last-child {
            margin-bottom: 0;
        }

        span {
            font-size: 16px;
            color: rgb(0, 0, 0);
        }
    }
}

.login-content-box {
    width: 420px;
    min-height: 480px;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(100, 100, 100, 0.38);
    border-radius: 2px;
    display: flex;
    margin: 50px 40px 0px 390px;

    &-1 {
        width: 420px;
        min-height: 348px;
        background-color: #fff;
        border-radius: 2px;
        position: relative;

        &-top {
            width: 100%;
            height: 60px;
            text-align: center;
            line-height: 100px;
            color: #db2a4b;
            font-size: 20px;
        }

        &-bottom {
            width: 360px;
            min-height: 350px;
            margin: 0 auto;
        }
    }

    .wx-icon {
        width: 22px;
        height: 22px;
        padding: 3px 5px;
        background-color: #3eb135;
        border-radius: 50%;
        display: inline-block;
        margin-right: 8px;

        img {
            width: 13px;
            height: 11px;
        }
    }
}

.F {
    display: flex;
    flex-direction: column;
    width: 360px;
    position: relative;

    .ivu-input {
        height: 42px;
    }

    &-1 {
        margin-top: 15px;
        margin-bottom: 0;

        .I {
            margin-top: 19px;
        }
    }

    .F-2 {
        width: 100%;
        height: 15px;
        line-height: 15px;
        display: flex;
        justify-content: flex-end;
        margin: 12px 0;

        .F-2-text {
            width: 75px;
            height: 13px;
            cursor: pointer;
            font-size: 14px;
            color: #666;
        }
    }
}

.login-re {
    text-align: center;
    margin-top: 20px;

    span {
        text-decoration: underline;
        font-size: 16px;
        color: #666;
        cursor: pointer;
    }
}

.code {
    width: 70px;
    height: 26px;
    position: absolute;
    top: 22px;
    right: 8px;
    cursor: pointer;
}

::v-deep .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal {
        top: 0;
    }
}

.button {
    width: 120px;
    height: 40px;
    background-color: #db2a4b;
    border-radius: 4px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px auto 40px;
    margin-bottom: 0;
    cursor: pointer;
}
</style>
